
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 4.5V4A1.5 1.5 0 012 2.5h12A1.5 1.5 0 0115.5 4v.5m0 0L9.273 8.236 8 9l-1.273-.764L.5 4.5m0 0V12m15-7.5V12M9.273 8.236L15.5 12m0 0a1.5 1.5 0 01-1.5 1.5H2A1.5 1.5 0 01.5 12m6.227-3.764L.5 12","stroke":"#000"}})])
          )
        }
      }
    